<button type="button" class="type-option" (click)="selected.emit()">
  <qai-icon [kind]="icon()" size="40px" [color]="'var(--fg-brand-primary)'" />
  <span class="type-option-title">{{ title() }}</span>
  <span class="type-option-description">{{ description() }}</span>
  <span class="type-option-best-for">{{ bestFor() }}</span>
</button>
